"use strict";

require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.search.js");
require("core-js/modules/es.array.reduce.js");
var _react = _interopRequireWildcard(require("react"));
var _constants = require("../../utils/constants");
var _material = require("@mui/material");
var _Localization = require("../../Localization");
var _styles = require("@mui/material/styles");
const _excluded = ["themeKey"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * @class Search
 * @param {string} theme
 * @param {Array} list
 * @param {string} label
 * @param {function} option
 * @param {object} activeFilters
 * @param {function} updateActiveFilters
 * @param {string} placeholder
 * @param {string} className
 * @param {styled} sx
 *
 * @return {JSX.Element}
 * @constructor
 */
const Search = _ref => {
  let {
    theme = _constants.defaultTheme,
    list = [],
    label = '',
    option = (item, tV) => "".concat(tV(item)),
    placeholder = 'Search',
    className,
    sx,
    activeFilters = {},
    updateActiveFilters
  } = _ref;
  const [open, setOpen] = _react.default.useState(false);
  const tV = (0, _Localization.useTranslationValue)();
  const input = (0, _react.useMemo)(() => activeFilters[_constants.filterTypes.search] || null, [activeFilters]);
  const handleInput = (0, _react.useCallback)(function () {
    let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    if (!Boolean(value)) {
      updateActiveFilters(Object.keys(activeFilters).reduce((acc, key) => key !== _constants.filterTypes.search ? _objectSpread(_objectSpread({}, acc), {}, {
        [key]: activeFilters[key]
      }) : acc, {}));
    } else {
      updateActiveFilters(_objectSpread(_objectSpread({}, activeFilters), {}, {
        [_constants.filterTypes.search]: value || ''
      }));
    }
  }, [activeFilters]);

  // const loading = open && list.length === 0;
  return (0, _react.useMemo)(() => /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "".concat(className || ''),
    sx: _objectSpread({
      width: 'auto',
      height: 40,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-evenly'
    }, sx || {})
  }, /*#__PURE__*/_react.default.createElement(StyledAutocomplete, {
    themeKey: theme,
    disablePortal: true
    // id="combo-box-demo"
    ,
    open: open,
    onOpen: () => setOpen(true),
    onClose: () => setOpen(false)
    // freeSolo
    ,
    options: list.map(item => option(item, tV))
    // loading={loading}
    ,
    className: "".concat(input ? 'active' : ''),
    value: input,
    onChange: (_, v) => handleInput(v),
    renderInput: params => /*#__PURE__*/_react.default.createElement(_material.TextField, _extends({}, params, {
      label: label,
      placeholder: placeholder,
      onSelect: e => handleInput(e.target.value),
      InputProps: _objectSpread(_objectSpread({}, params.InputProps), {}, {
        className: "".concat(input ? 'active' : ''),
        endAdornment: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, params.InputProps.endAdornment)
      })
    }))
  })), [className, open, list, placeholder, theme, input, handleInput, sx]);
};
const StyledAutocomplete = (0, _styles.styled)(_ref2 => {
  let {
      themeKey
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/_react.default.createElement(_material.Autocomplete, props);
})(_ref3 => {
  let {
    themeKey: propsThemeKey
  } = _ref3;
  const isDark = propsThemeKey === _constants.themeKey.dark;
  return {
    '& .MuiFormLabel-root': {
      transform: 'translate(14px, 10px) scale(1)',
      '&.Mui-focused, &.MuiFormLabel-filled': {
        transform: 'translate(14px, -9px) scale(.75)',
        color: 'var(--main-color-cl-01)'
      }
    },
    '& .MuiInputBase-root': {
      padding: '1px 40px 1px 16px',
      transition: 'var(--transition02)',
      borderRadius: 'var(--input-br)',
      input: {
        padding: 0,
        '&::placeholder': {
          color: 'var(--main-color-cl-13)',
          opacity: 1
        }
      },
      '& .MuiOutlinedInput-notchedOutline': {
        color: 'var(--main-color-cl-13)',
        border: '1px solid var(--main-color-cl-13)',
        borderRadius: 'var(--input-br)',
        transition: 'var(--transition02)',
        top: '-7px',
        '&.Mui-focused': {
          color: 'var(--main-color-cl-13)',
          border: '1px solid var(--main-color-cl-13)'
        }
      },
      '&:hover, &:focus-within': {
        '&': isDark ? {
          backgroundColor: 'var(--main-color-cl-08)'
        } : {},
        '& .MuiOutlinedInput-notchedOutline': {
          color: 'var(--main-color-cl-01)',
          border: '1px solid',
          borderColor: isDark ? 'var(--main-color-cl-08)' : 'var(--main-color-cl-01)'
        },
        input: {
          // color: 'var(--main-color-cl-08)',
          '&::placeholder': isDark ? {
            color: 'var(--main-color-cl-13)'
          } : {}
        }
      }
    },
    svg: {
      color: 'var(--main-color-cl-13)'
    },
    '&.active:not(&.Mui-focused)': {
      '& .MuiFormLabel-root': {
        // color: 'var(--main-color-cl-08)',
        color: 'transparent'
      },
      '& .MuiInputBase-root': {
        backgroundColor: isDark ? 'var(--main-color-cl-30)' : 'var(--main-color-cl-01)',
        input: {
          color: 'var(--main-color-cl-08)'
        },
        '& .MuiOutlinedInput-notchedOutline': isDark ? {
          borderColor: 'var(--main-color-cl-30)'
        } : {}
      },
      svg: {
        color: 'var(--main-color-cl-08)'
      }
    },
    '& ~ div ': {
      marginTop: '13px',
      borderRadius: 0,
      boxShadow: 'var(--main-form-shadow)',
      '& > .MuiPaper-root ul': {
        padding: 0,
        '.MuiAutocomplete-option': {
          minHeight: 40,
          color: 'var(--main-color-cl-01)',
          display: 'block',
          lineHeight: '180%',
          borderBottom: '1px solid var(--main-color-cl-19)',
          '&.Mui-selected': {
            background: 'inherit'
          },
          '&[aria-selected="true"]': {
            background: 'var(--main-color-cl-19)'
          },
          '&:hover': {
            background: 'var(--main-color-cl-17)'
          }
        }
      }
    }
  };
});
var _default = exports.default = Search;